import { Trans, useTranslation } from 'react-i18next';
import styles from './ProblemSection.module.css';
import sharedStyles from '../../../../models/css/sharedStyles.module.css';
import { motion } from "framer-motion";
import { container, item } from '../../../utils/animations';
import { ProblemCard } from './ProblemCard';

export const ProblemSection = () => {
    const {t} = useTranslation();
    return (
        <div className={styles.wrapper}>
            <motion.div
                className={styles.container}
                variants={container}
                initial="hidden"
                whileInView="show"
                viewport={{
                    once: true,
                    amount: 0.2,
                }}
            >
                <motion.h1
                    className={sharedStyles.mainTitle}
                    variants={item}
                >
                    <Trans
                        i18nKey="home.problemSection.title"
                        components={[
                            <span className={styles.textCoursive} />
                        ]}
                    />
                </motion.h1>

                <div className={styles.cardList}>
                    <ProblemCard 
                        image={require('../../../../assets/images/events/event_one.png')} 
                        description={t('home.problemSection.cards.one')}
                        color={'#FFDE59'}
                    />
                    <ProblemCard 
                        image={require('../../../../assets/images/events/event_two.png')} 
                        description={t('home.problemSection.cards.two')}
                        color={'#E2A9F1'}
                    />
                    <ProblemCard 
                        image={require('../../../../assets/images/events/event_three.png')} 
                        description={t('home.problemSection.cards.three')}
                        color={'#ffbd59'}
                    />
                </div>

            </motion.div>
        </div>
    )
}